import { render, staticRenderFns } from "./btnM.vue?vue&type=template&id=395b2bde&scoped=true&"
import script from "./btnM.vue?vue&type=script&lang=js&"
export * from "./btnM.vue?vue&type=script&lang=js&"
import style0 from "./btnM.vue?vue&type=style&index=0&id=395b2bde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b2bde",
  null
  
)

export default component.exports